module.exports = __webpack_public_path__ + "img/emptyState.7f82ec7e.png";